import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminHeaderComponent } from '../../shared/widgets/admin-header/admin-header.component';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SupportSidemenuComponent } from '../../shared/widgets/support-sidemenu/support-sidemenu.component';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../core/store';
import { Subscription } from 'rxjs';
import { getSettingsStore } from '../../core/store/selectors/settings.selectors';

@Component({
  selector: 'app-support-layout',
  standalone: true,
  imports: [
    RouterModule,
    AdminHeaderComponent,
    CommonModule,
    NzLayoutModule,
    NzMenuModule,
    NgScrollbarModule,
    NzToolTipModule,
    SupportSidemenuComponent,
  ],
  templateUrl: './support.component.html',
})
export class SupportLayoutComponent {
  store = inject(Store<AppState>);

  settingsStoreSub?: Subscription;

  isCollapsed = false;

  ngOnInit(): void {
    this.settingsStoreSub = this.store
      .pipe(select(getSettingsStore))
      .subscribe((settingsStore) => {
        this.isCollapsed = settingsStore.sideMenuCollapsedState;
      });
  }

  ngOnDestroy(): void {
    if (this.settingsStoreSub) this.settingsStoreSub.unsubscribe();
  }
}
